// =====================================================
// 📁 QuotationProductItem.tsx
// =====================================================


import { ProductPanelItem } from '../../../../../../types/productpanel/ProductPanelItem';
import QuotationProductCardItem from '../card/QuotationProductCardItem';
import QuotationProductListItem from '../list/QuotationProductListItem';


interface Props {
  product: ProductPanelItem;

  mode?: 'card' | 'list';

  quantity?: number;

  disabled?: boolean;

  onAddProductClick?: (product: ProductPanelItem) => void;

  onIncreaseQuantity?: (product: ProductPanelItem) => void;

  onDecreaseQuantity?: (product: ProductPanelItem) => void;
}

const QuotationProductItem = ({
  product,

  mode = 'card',

  quantity,

  disabled,

  onAddProductClick,

  onIncreaseQuantity,

  onDecreaseQuantity,
}: Props) => {
  // =====================================================
  // 🔹 List Mode
  // =====================================================
  if (mode === 'list') {
    return (
      <QuotationProductListItem
        product={product}
        quantity={quantity}
        disabled={disabled}
        onAddProductClick={onAddProductClick}
        onIncreaseQuantity={onIncreaseQuantity}
        onDecreaseQuantity={onDecreaseQuantity}
      />
    );
  }

  // =====================================================
  // 🔹 Card Mode
  // =====================================================
  return (
    <QuotationProductCardItem
      product={product}
      quantity={quantity}
      disabled={disabled}
      onAddProductClick={onAddProductClick}
      onIncreaseQuantity={onIncreaseQuantity}
      onDecreaseQuantity={onDecreaseQuantity}
    />
  );
};

export default QuotationProductItem;
